import { createSignal, Show } from 'solid-js'
import './Modal.css'
import { userStore } from '/web/store'
import LoginFormSocialButtons from './LoginFromSocialButtons'

interface Props {
  onClickLogin?: any
  onClickRegister?: any
}

const ENABLE_SOCIAL_LOGIN = true

const RegisterFormModal = (props: Props) => {
  const user = userStore()

  const [showPassword, setShowPassword] = createSignal(false)

  const togglePasswordVisibile = () => {
    setShowPassword(!showPassword())
  }

  return (
    <Show when={user.showLogin}>
      <div
        class="fixed bottom-0  left-0 right-0 top-0  z-[200] flex h-screen items-center justify-center overflow-y-auto overflow-x-hidden bg-black/80 backdrop-blur"
        onClick={(e) => {
          userStore.loginModal(false)
        }}
      >
        <div
          onClick={(e) => {
            e.stopPropagation()
          }}
          class="background m-5 w-full rounded-2xl border-[1px] border-white p-[18px] backdrop-blur md:w-[400px]"
        >
          <div class="font-clash">
            <h3 class="mb-5 mt-1 font-clash text-2xl font-bold leading-normal text-white">
              User Sign Up
            </h3>
            <LoginFormSocialButtons show={ENABLE_SOCIAL_LOGIN} user={user} isRegister />
            <form onSubmit={props.onClickRegister}>
              <div class="mb-4 flex flex-col">
                <label
                  for="username"
                  class="mb-2 block font-clash text-base font-semibold text-white"
                >
                  Username
                </label>
                <input
                  name="username"
                  placeholder="Enter Username"
                  class="rounded-md border border-white bg-white/10 p-4 text-xs"
                />
              </div>
              <div class="mb-4 flex flex-col">
                <label for="email" class="mb-2 block font-clash text-base font-semibold text-white">
                  Email Address
                </label>
                <input
                  name="email"
                  placeholder="Enter Email Address"
                  class="rounded-md border border-white bg-white/10 p-4 text-xs"
                />
              </div>
              <div class="mb-4 flex flex-col">
                <label
                  for="password"
                  class="mb-2 block font-clash text-base font-semibold text-white"
                >
                  Password
                </label>
                <div class="relative flex">
                  <input
                    name="password"
                    type={showPassword() ? 'text' : 'password'}
                    placeholder="Enter Password"
                    class="flex-1 rounded-md border border-white bg-white/10 p-4 text-xs"
                  />
                  <div class="absolute inset-y-0 right-4 flex items-center justify-center">
                    <button type="button" onClick={() => togglePasswordVisibile()}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M1.91172 8.92527C1.41589 8.28127 1.16797 7.95869 1.16797 7.0026C1.16797 6.04594 1.41589 5.72452 1.91172 5.07994C2.90164 3.79427 4.5618 2.33594 7.0013 2.33594C9.4408 2.33594 11.101 3.79427 12.0909 5.07994C12.5867 5.7251 12.8346 6.04652 12.8346 7.0026C12.8346 7.95927 12.5867 8.28069 12.0909 8.92527C11.101 10.2109 9.4408 11.6693 7.0013 11.6693C4.5618 11.6693 2.90164 10.2109 1.91172 8.92527Z"
                          stroke="#10E0F9"
                          stroke-width="1.5"
                        />
                        <path
                          d="M8.75 7C8.75 7.46413 8.56563 7.90925 8.23744 8.23744C7.90925 8.56563 7.46413 8.75 7 8.75C6.53587 8.75 6.09075 8.56563 5.76256 8.23744C5.43437 7.90925 5.25 7.46413 5.25 7C5.25 6.53587 5.43437 6.09075 5.76256 5.76256C6.09075 5.43437 6.53587 5.25 7 5.25C7.46413 5.25 7.90925 5.43437 8.23744 5.76256C8.56563 6.09075 8.75 6.53587 8.75 7Z"
                          stroke="#10E0F9"
                          stroke-width="1.5"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <button
                type="submit"
                class="mb-3 mt-5 h-12 w-full rounded-md bg-gradient-to-r from-cosplay-blue-200 to-cosplay-purple font-clash font-semibold text-white"
              >
                Sign Up
              </button>
              <p class="text-center text-xs">
                By Registering Your Accept Our{' '}
                <a class="font-semibold" href="/privacy-policy/">
                  Privacy Policy
                </a>
              </p>
              <p class="mt-6 text-center text-sm text-white">
                Already Have An Account?&nbsp;&nbsp;
                <a
                  onclick={props.onClickLogin}
                  href="#"
                  class="font-clash font-semibold text-[#FF23FF]"
                >
                  Log In
                </a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </Show>
  )
}

export default RegisterFormModal
